/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_DesignInputs */

const en_val_design = /** @type {(inputs: Val_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design`)
};

const es_val_design = /** @type {(inputs: Val_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseño`)
};

const fr_val_design = /** @type {(inputs: Val_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design`)
};

const de_val_design = /** @type {(inputs: Val_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design`)
};

const ja_val_design = /** @type {(inputs: Val_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デザイン`)
};

const zh_val_design = /** @type {(inputs: Val_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设计`)
};

const ar_val_design = /** @type {(inputs: Val_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصميم`)
};

const id_val_design = /** @type {(inputs: Val_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desain`)
};

const it_val_design = /** @type {(inputs: Val_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design`)
};

const ru_val_design = /** @type {(inputs: Val_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дизайн`)
};

const pt_val_design = /** @type {(inputs: Val_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design`)
};

const ko_val_design = /** @type {(inputs: Val_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디자인`)
};

/**
* | output |
* | --- |
* | "Design" |
*
* @param {Val_DesignInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_design = /** @type {((inputs?: Val_DesignInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_DesignInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_design(inputs)
	if (locale === "es") return es_val_design(inputs)
	if (locale === "fr") return fr_val_design(inputs)
	if (locale === "de") return de_val_design(inputs)
	if (locale === "ja") return ja_val_design(inputs)
	if (locale === "zh") return zh_val_design(inputs)
	if (locale === "ar") return ar_val_design(inputs)
	if (locale === "id") return id_val_design(inputs)
	if (locale === "it") return it_val_design(inputs)
	if (locale === "ru") return ru_val_design(inputs)
	if (locale === "pt") return pt_val_design(inputs)
	return ko_val_design(inputs)
});